module.exports.ACCOUNT_NAV_ITEMS = {
  general: {
    path: '/account/general',
    subpage: 'general',
    titleId: 'account/nav/AccountNav.tsx/1',
    internal: true,
    icon: 'account_circle',
    subtitleId: 'account/nav/AccountNav.tsx/2',
  },
  legal_domains: {
    path: '/domains_selection',
    subpage: '',
    titleId: 'account/nav/AccountNav.tsx/5',
    internal: true,
    icon: 'stars',
    subtitleId: 'account/nav/AccountNav.tsx/6',
  },
  notifications: {
    path: '/account/notifications',
    subpage: 'notifications',
    titleId: 'account/nav/AccountNav.tsx/7',
    internal: true,
    icon: 'notifications',
    subtitleId: 'account/nav/AccountNav.tsx/8',
  },
  org_member_management: {
    path: '/account/organization_members',
    subpage: 'organization_members',
    titleId: 'account/nav/AccountNav.tsx/9',
    internal: true,
    icon: 'business',
    subtitleId: 'account/nav/AccountNav.tsx/10',
  },
  billing: {
    path: '/account/billing',
    subpage: 'billing',
    titleId: 'account/nav/AccountNav.tsx/3',
    internal: true,
    icon: 'credit_card',
    subtitleId: 'account/nav/AccountNav.tsx/4',
  },
};
